import { render, staticRenderFns } from "./FeaturePhotoBox.vue?vue&type=template&id=29706ace&scoped=true&"
import script from "./FeaturePhotoBox.vue?vue&type=script&lang=js&"
export * from "./FeaturePhotoBox.vue?vue&type=script&lang=js&"
import style0 from "./FeaturePhotoBox.vue?vue&type=style&index=0&id=29706ace&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29706ace",
  null
  
)

export default component.exports